import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, LoadingOverlay, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { authApi } from '../api/client';

interface SSOCallbackProps {
    onLogin: () => void;
}

export default function SSOCallback({ onLogin }: SSOCallbackProps) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = searchParams.get('token');

        if (!token) {
            notifications.show({
                title: 'Error',
                message: 'No token provided',
                color: 'red',
            });
            navigate('/');
            return;
        }

        authApi
            .ssoLogin(token)
            .then(() => {
                onLogin();
                navigate('/');
            })
            .catch(() => {
                notifications.show({
                    title: 'Authentication failed',
                    message: 'Invalid or expired token',
                    color: 'red',
                });
                navigate('/');
            });
    }, [searchParams, navigate, onLogin]);

    return (
        <Container size={420} my={40}>
            <LoadingOverlay visible zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
            <Text ta="center" size="lg" mt="xl">
                Connecting...
            </Text>
        </Container>
    );
}
